import { useContext } from 'react';

import { PatientIntakeStatusContext } from '../PatientIntakeStatusContext.tsx';

export const usePatientIntakeStatusContext = () => {
  const context = useContext(PatientIntakeStatusContext);

  if (!context) {
    throw new Error('usePatientIntakeStatusContext must be used within a PatientIntakeStatusProvider');
  }

  return context;
};
